import * as React from "react";
import { ChartContainer } from "@mui/x-charts";
import { LinePlot, MarkPlot } from "@mui/x-charts/LineChart";

// const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
// const xLabels = [
//   "Page A",
//   "Page B",
//   "Page C",
//   "Page D",
//   "Page E",
//   "Page F",
//   "Page G",
// ];
const pData = [10, 13, 7];
const xLabels = pData;

export default function LineChart({ data }: { data: number[] }) {
  const containerSize = 100;

  const stokeColor =
    data[data.length - 1] - data[data.length - 2] > 0
      ? "#C41C1C"
      : "var(--joy-palette-primary-500, #0B6BCB)";
  return (
    <div
      className="relative"
      style={{ width: containerSize, height: containerSize }}
    >
      <div className="absolute top-0 left-0 w-full h-full origin-top-left scale-[0.2]">
        <ChartContainer
          width={containerSize * 5}
          height={containerSize * 5}
          series={[{ type: "line", data: data }]}
          xAxis={[
            {
              scaleType: "point",
              data: data.map((each, index) => `${index}`),
            },
          ]}
          sx={{
            ".MuiLineElement-root": {
              stroke: stokeColor,
              strokeWidth: 10,
            },
            ".MuiMarkElement-root": {
              stroke: stokeColor,
              scale: "0.6",
              fill: stokeColor,
              strokeWidth: 2,
            },
          }}
          disableAxisListener
        >
          <LinePlot />
          <MarkPlot />
        </ChartContainer>
      </div>
    </div>
  );
}
